import { computed } from 'vue'
import { useStore } from 'vuex'

/**
 * Composable that provides device-related information from the store
 * Replaces the Vue 2 DeviceAware mixin
 *
 * @returns {Object} Device-related computed properties
 */
export function useDeviceAware() {
  const store = useStore()

  const isExtension = computed(() => store.getters['device/isExtension'])
  const isExtensionPopup = computed(() => store.getters['device/isExtensionPopup'])
  const isDesktop = computed(() => store.getters['device/isDesktop'])
  const isWebApp = computed(() => store.getters['device/isWeb'])
  const isMobile = computed(() => store.getters['device/isMobile'])
  const isNative = computed(() => store.getters['device/isNative'])
  const deviceInfo = computed(() => store.getters['device/all'])

  return {
    isExtension,
    isExtensionPopup,
    isDesktop,
    isWebApp,
    isMobile,
    isNative,
    deviceInfo
  }
}
